var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-box"},[_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.items),function(item){return _c('swiper-slide',{key:item.sort},[_c('img',{attrs:{"src":item.thumb,"name":item.url}})])}),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }